<template>
  <div>
    <a-layout id="components-layout-demo-side" style="background: white;">
      <a-layout-sider style="height:100%">
        <selectTree
          ref="myTree"
          :option="treeOption"
          @selectedTree="receiveData"
        />
      </a-layout-sider>
      <a-layout style="background: white;">
        <div style="padding:15px">
          <data-table ref="dataTable" :option="option"> </data-table>
        </div>
      </a-layout>
    </a-layout>
    <!-- 产品规则-->
    <a-modal
      centered
      :maskClosable="false"
      title="产品规则"
      v-model="productRuleModal"
      width="1000px"
      :destroyOnClose="true"
      :footer="null"
    >
      <div style="height: 10px;"></div>
      <div style="height: 560px;">
        <product-rule :productId="productId"> </product-rule>
      </div>
    </a-modal>
  </div>
</template>

<script>
import SelectTree from "@/components/dataTree/SelectTree";
import { DataTable } from "@/components/dataTable";
import ProductRule from "@/views/channelManage/ProductRule";

export default {
  name: "channelManage_channelProduct",
  components: { SelectTree, DataTable, ProductRule },
  props: {},
  data() {
    return {
      channelId: null,
      productId: null,
      treeOption: {
        //URL数据请求地址
        api: "Common_GetSelect",
        params: { Types: "channel" },
        //数据字段
        dataField: "Data.channel",
        //标题字段
        title: "Text",
        //子数组字段
        children: "Childs",
        //选择值字段
        keyValue: "Id",
        //使用模式
        checkMode: "childrenMode"
      },
      productRuleModal: false,
      roomCountData: [],
      roomCount: 0
    };
  },
  created() {
    this.option = {
      form: {
        colnum: 1,
        width: 550,
        title: "产品",
        add: {
          submitApi: "Product_Add",
          onOpenAfter: () => {
            return {
              RoomShared: "0",
              ChannelId: this.channelId,
              ValidStatus: "1",
              IsNeedConfirm: "0"
              // IsVerifyPrice: "0"
            };
          },
          onSubmitBefore: values => {
            // values.IsVerifyPrice = values.IsVerifyPrice == "1" ? true : false;
            values.IsNeedConfirm = values.IsNeedConfirm == "1" ? true : false;
            return values;
          }
        },
        edit: {
          infoApi: "Product_Info",
          submitApi: "Product_Edit",
          onOpenAfter: res => {
            const result = this.roomCountData.find(
              el => el.RoomTypeId == res.Data.RoomTypeId
            );
            this.roomCount = result ? result.RoomCount : 0;
            const values = {
              ...res.Data,
              // IsVerifyPrice: res.Data.IsVerifyPrice ? "1" : "0",
              IsNeedConfirm: res.Data.IsNeedConfirm ? "1" : "0"
            };
            return values;
          },
          onSubmitBefore: values => {
            // values.IsVerifyPrice = values.IsVerifyPrice == "1" ? true : false;
            values.IsNeedConfirm = values.IsNeedConfirm == "1" ? true : false;
            return values;
          }
        },
        del: { submitApi: "Product_Del" },
        content: [
          {
            label: "渠道",
            name: "ChannelId",
            type: "select",
            api: "Common_GetSelect",
            param: { types: "channel" },
            dataField: "Data.channel",
            props: { disabled: true }
          },
          {
            label: "房型",
            name: "RoomTypeId",
            type: "select",
            api: "Common_GetSelect",
            param: { types: "roomType" },
            dataField: "Data.roomType",
            option: {
              rules: [{ required: true, message: "请填写房型！" }]
            },
            onChange: value => {
              const res = this.roomCountData.find(el => el.RoomTypeId == value);
              this.roomCount = res ? res.RoomCount : 0;
            },
            extra: () => {
              return (
                <span>
                  （房间总量：
                  <span style="color:#f00;font-size:16px">
                    {this.roomCount}
                  </span>
                  ）
                </span>
              );
            }
          },
          {
            label: "价格代码",
            name: "PriceCodeId",
            type: "select",
            api: "Common_GetSelect",
            param: { types: "priceCode" },
            dataField: "Data.priceCode",
            option: {
              rules: [{ required: true, message: "请填写价格代码！" }]
            }
          },
          {
            label: "基础房数",
            name: "BaseRoomCount",
            type: "number", //计数器
            min: 0,
            option: {
              rules: [{ required: true, message: "请填写基础房数！" }]
            }
          },
          {
            label: "价构",
            name: "PriceStructureId",
            type: "select",
            api: "Common_GetSelect",
            param: { types: "PriceStructure" },
            dataField: "Data.PriceStructure",
            onChange: (val, sel) => {
              const targetId = document.getElementById("BreakfastCount");
              if (sel && sel.Data && sel.Data.Num != undefined) {
                this.$nextTick(() => {
                  const data = this.$refs.dataTable.getFormData();
                  this.$refs.dataTable.setFormData({
                    ...data,
                    BreakfastCount: sel.Data.Num
                  });
                  this.$common.addClass(targetId, "shake-field");
                  setTimeout(() => {
                    this.$common.removeClass(targetId, "shake-field");
                  }, 2000);
                });
              }
            }
          },
          {
            label: "含早数",
            name: "BreakfastCount",
            type: "number", //计数器
            min: 0,
            option: {
              rules: [{ required: true, message: "请填写含早数！" }]
            }
          },
          // {
          //   label: "房数共享模式",
          //   name: "RoomShared",
          //   type: "select",
          //   api: "Common_GetSelect",
          //   param: { types: "RoomShared" },
          //   dataField: "Data.RoomShared",
          //   option: {
          //     rules: [{ required: true, message: "请填写房数共享模式！" }]
          //   }
          // },
          // {
          //   label: "开启价格验证",
          //   name: "IsVerifyPrice",
          //   type: "select",
          //   valueField: "value", //可选项数据值字段
          //   textField: "text", //可选项数据文本字段
          //   data: [
          //     {
          //       value: "1",
          //       text: "是"
          //     },
          //     {
          //       value: "0",
          //       text: "否"
          //     }
          //   ]
          // },
          {
            label: "是否需要确认",
            name: "IsNeedConfirm",
            type: "select",
            valueField: "value", //可选项数据值字段
            textField: "text", //可选项数据文本字段
            data: [
              {
                value: "1",
                text: "是"
              },
              {
                value: "0",
                text: "否"
              }
            ]
          },
          {
            label: "状态",
            name: "ValidStatus",
            option: {
              rules: [{ required: true, message: "请选择状态！" }]
            },
            type: "select",
            valueField: "value", //可选项数据值字段
            textField: "text", //可选项数据文本字段
            data: [
              {
                value: "1",
                text: "启用"
              },
              {
                value: "0",
                text: "禁用"
              }
            ]
          }
          // {
          //   label: "是否需要确认",
          //   name: "IsNeedConfirm",
          //   type: "checkbox"
          // }
        ]
      },
      grid: {
        api: "Product_List",
        params: { ChannelId: this.channelId },
        columns: [
          {
            title: "序号",
            width: "5%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "渠道名称",
            width: "10%", //宽度
            dataIndex: "ChannelName"
          },
          {
            title: "状态",
            width: "5%",
            dataIndex: "ValidStatusName"
          },
          {
            title: "房型名称",
            width: "10%",
            dataIndex: "RoomTypeName"
          },
          {
            title: "价格代码",
            width: "12%",
            dataIndex: "PriceCodeName"
          },
          {
            title: "基础房数",
            width: "8%",
            dataIndex: "BaseRoomCount"
          },
          {
            title: "价构",
            width: "7%",
            dataIndex: "PriceStructureName"
          },
          {
            title: "含早数  ",
            width: "6%",
            dataIndex: "BreakfastCount"
          },
          // {
          //   title: "共享模式",
          //   width: "8%",
          //   dataIndex: "SharedModelName"
          // },
          // {
          //   title: "开启价格验证",
          //   width: "12%",
          //   dataIndex: "IsVerifyPrice",
          //   customRender: (text, record) => {
          //     return text ? "是" : "否";
          //   }
          // },
          // {
          //   title: "价格验证模式",
          //   width: "10%",
          //   dataIndex: "VerifyPriceModel",
          //   customRender: (text, record) => {
          //     return text ? "不超出价格波动范围" : "价格必须相等";
          //   }
          // },
          {
            title: "是否需要确认",
            width: "12%",
            dataIndex: "IsNeedConfirm",
            customRender: text => {
              return text ? "是" : "否";
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            key: "action",
            //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
            //scopedSlots: { customRender: "rowAction" }
            customRender: (text, record) => {
              const edit = {
                click: () => {
                  this.edit(record.Id);
                }
              };
              const rule = {
                click: () => {
                  this.productId = record.Id;
                  this.productRuleModal = true;
                }
              };
              const del = {
                confirm: () => {
                  this.del(record.Id);
                }
              };
              return (
                <div>
                  <a-button type="link" size="small" {...{ on: edit }}>
                    编辑
                  </a-button>{" "}
                  |{" "}
                  <a-button type="link" size="small" {...{ on: rule }}>
                    规则
                  </a-button>{" "}
                  |{" "}
                  <a-popconfirm
                    title="你确认删除吗？"
                    {...{ on: { ...del } }}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a-button type="link" size="small">
                      删除{" "}
                    </a-button>
                  </a-popconfirm>
                </div>
              );
            }
          }
        ]
      }
    };
    this.$post("GetEachRoomTypeCount", {}).then(res => {
      this.roomCountData = res.Data;
    });
  },
  mounted() {},
  methods: {
    edit(Id) {
      this.$refs.dataTable.edit(Id);
    },
    del(Id) {
      this.$refs.dataTable.del({ Id: Id });
    },
    receiveData(Data) {
      if (Data.treeSelect) {
        this.channelId = Data.treeSelect;
        //刷新右边页面
        this.option.grid.params = { ChannelId: this.channelId };
        this.$refs.dataTable.$refs.dataGrid.reload();
      }
    }
  },
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
